import { useContext, useEffect, useState } from "react";
import { getMasters, createMasters, updateMasters, deleteMasters } from "../services/configurations/pointsOfAttention/masters";
import { AppContext } from "../context";

type DataResponseType = "DATA" | "ID";
type ActionType = "CREATE" | "UPDATE" | "DELETE";

const handleActionFunction = (action: ActionType, t: Function) => {
  switch (action) {
    case "CREATE":
      return {
        actionFn: createMasters,
        fnMsg: t("PointsOfAttention.masterApiCreateLabel"),
      };
      case "UPDATE":
        return {
          actionFn: updateMasters,
          fnMsg: t("Users.usersApiUpdateLabel"),
        };
    case "DELETE":
      return {
        // deleteUser service here
        actionFn: deleteMasters,
        fnMsg: t("Users.usersApiDeleteLabel"),
      };
    default:
      return {
        actionFn: () => {},
        fnMsg: "",
      };
  }
};

export const useMasters = (type: DataResponseType) => {
  const {
    t,
    toast,
    appState: { selectedApp },
    setAppState,
  } = useContext(AppContext);
  const [dataMaster, setDataMaster] = useState<any | null>(null);
  const [reload, setReload] = useState<number>(0);

  const reloadFnMaster = () => {
    setDataMaster(null);
    setReload((prev) => prev + 1);
  };

  const masterAction = async (action: ActionType, data: any) => {
    const { actionFn, fnMsg } = handleActionFunction(action, t);
    setAppState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const actionStatus = await Promise.resolve(actionFn(data, selectedApp?.tenantid!))
      .then((response) => {
        toast.current.replace({
          severity: "success",
          summary: "",
          detail: `${fnMsg}`,
          life: 3000,
        });
        return "SUCCESS";
      })
      .catch((error) => {
        toast.current.replace({
          severity: "error",
          summary: "",
          detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
          life: 3000,
        });
        return "ERROR";
      });
    setAppState((prev) => ({
      ...prev,
      isLoading: false,
    }));
    return actionStatus;
  };

  useEffect(() => {
    if (type === "DATA") {
      (async function () {
        await Promise.resolve(getMasters(selectedApp?.tenantid!))
          .then((response) => {
            const serviceResponse = response?.data;
            setDataMaster(serviceResponse);
          })
          .catch((error) => {
            toast.current.replace({
              severity: "error",
              summary: "",
              detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
              life: 3000,
            });
          });
      })();
    }
  }, [toast, reload, type, setAppState]);

  return {
    dataMaster,
    masterAction,
    reloadFnMaster,
  };
};